import React, { Component } from 'react';
import PropTypes from "prop-types";

import withStyles from "@material-ui/core/styles/withStyles";
import { Divider, Icon } from '@material-ui/core';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import {Link} from "react-router-dom";

// core components
import CardFooter from "components/Card/CardFooter.jsx";
import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

// styles
import cardStyles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.jsx";


const styles = () => ({
    ...cardStyles,
    cardFooterDivider: {width: '100%'},
    footerFullWidth: {width: '100%'},
    articleLeftIcon: {paddingLeft: 0},
    articleRightIcon: {
        paddingRight: 0,
        "@media screen and (max-width: 900px)": {
            display: 'none'
        }
    },
    articleDetailsIcon: {
        paddingRight: 0,
        display: 'block',
        paddingTop: '6px',

        "@media screen and (max-width: 900px)": {
            display: 'none'
        }
    },
    endAlign: {float: 'right'},
    myAvatar: {
        objectFit: 'cover',
        maxHeight: '18px',
        paddingRight: '10px',
        fontSize: '0.7rem'
    },
    articleEditButton: {
        width: '15px',
        height: '15px',
        color: "#000000 !important",
    }
})

class ArticleFooter extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { classes, record } = this.props;
        const { clickOpenFunc } = this.props;

        return (
            <CardFooter className={classes.cardBodyRotate}>
                <Divider className={classes.cardFooterDivider} />
                <GridContainer className={classes.footerFullWidth}>
                    <GridItem xs={12} sm={8} md={8} className={classes.articleLeftIcon}>
                        <div className={`${classes.stats} ${classes.mlAuto}`}>
                            <a style={{color: "#000000"}} href={record.base_url} target="_blank" rel="noopener noreferrer">
                                <h6>
                                    <img src={record.icon_url} className={`${classes.imgRaised} ${classes.myAvatar}`} alt="" />
                                    {record.site_name}
                                </h6>
                            </a>
                        </div>
                    </GridItem>
                    <GridItem xs={2} sm={2} md={2} className={classes.articleDetailsIcon}>
                        <Link to={`/details/${record.data_id}`} target="_blank">
                            <MoreHorizIcon />
                        </Link>
                    </GridItem>
                    <GridItem xs={12} sm={2} md={2} xl={2} className={classes.articleRightIcon}>
                        <div className={`${classes.stats} ${classes.mlAuto} ${classes.endAlign}`}>
                            <Button 
                                simple justIcon color="primary" size="sm" 
                                className={classes.articleEditButton}
                                onClick={clickOpenFunc}>
                                <Icon>mode_edit</Icon>
                            </Button>
                        </div>
                    </GridItem>
                </GridContainer>
                
            </CardFooter>
        )
    }
}

ArticleFooter.propTypes = {
    classes: PropTypes.object,
    record: PropTypes.object,
    clickOpenFunc: PropTypes.func
}

export default withStyles(styles)(ArticleFooter);


// WEBPACK FOOTER //
// ./src/components/Article/common/ArticleFooter.jsx